module.exports = __webpack_public_path__ + "img/pictoDiagnosis.6ff10d66.svg";